<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    [width]="isSimpleMode ? '6.08rem' : '7rem'"
    [loading]="loading"
    (onHide)="close()">
    <n-header>
        <h1>{{i18n.configServiceAdTitleLab}}</h1>
        <n-help-link key="serviceAdView"></n-help-link>
    </n-header>
    <n-retry *ngIf="loadFailed" (retry)="refresh()"></n-retry>

    <form *ngIf="!loadFailed && vm"
        [errorMessage]="errorMessage"
        [formGroup]="vm"
        [simpleMode]="isSimpleMode"
        class="common-form">
        <!-- 所属租户 -->
        <n-form-item [label]="i18n.vstoreLab" *ngIf="!isSimpleMode">
            <div class="n-form-item-text">{{data.vstoreName || UNPLACEHOLDER}}</div >
        </n-form-item>
        <!-- 域管理员 -->
        <n-form-item [label]="i18n.domainUserNameLab"
            [required]="true">
            <input type="text"
                id="service-ad-username"
                nInput
                formControlName="ADMINNAME">
            <!-- 添加一个隐藏的输入框来欺骗firefox等浏览器的自动填充，离密码框要近 -->
            <input type="text" class="hidden">
        </n-form-item>
        <!-- 密码 -->
        <n-form-item [label]="i18n.passwordLab"
            [required]="true">
            <!-- 添加一个隐藏的输入框来欺骗firefox等浏览器的自动填充，离密码框要近 -->
            <input type="password" class="hidden">
            <input type="password"
                id="service-ad-password"
                nInput
                formControlName="ADMINPWD">
        </n-form-item>
        <!-- 全域名 -->
        <n-form-item [label]="i18n.fullDomainNameLab"
            [required]="true">
            <div class="interval-10">
                <input type="text"
                    id="service-ad-full-domain-name"
                    nInput
                    formControlName="FULLDOMAINNAME">
                <button id="full-domain-name-test"
                    nButton
                    [label]="i18n.testBtn"
                    [disabled]="!vm.get('FULLDOMAINNAME')['_pendingValue']"
                    (click)="test('FULLDOMAINNAME')">
                </button>
            </div>
            <!-- DNS服务未配置 -->
            <n-tip *ngIf="!hasDns"
                class="dns-check-tip"
                type="info">
                <span style="white-space: pre;">{{i18n.checkDnsConfigrueTip}}</span>
                <button id="full-domain-name-test"
                    nButton
                    theme="text"
                    [label]="i18n.setDnsConfigrue"
                    (click)="openDnsConfigure()"></button>
                <span>{{ i18n.preiod }}</span>
            </n-tip>
        </n-form-item>
        <!-- 组织单元 -->
        <n-form-item [label]="i18n.organizeUnitLab" [showAvailableLabel]="simpleModeStyle">
            <input type="text"
                id="service-ad-ou"
                nInput
                formControlName="OU">
        </n-form-item>
        <!-- 系统名称 -->
        <n-form-item [label]="i18n.systemNameLab"
            [helpContent]="i18n.sysNameTip"
            [required]="true">
            <input type="text"
                id="service-ad-system-name"
                nInput
                formControlName="SYSTEMNAME">
            <n-tip
                [type]="'info'"
                [content]="i18n.systemNameInfoValid">
            </n-tip>
        </n-form-item>
        <!-- 覆盖系统名称 -->
        <n-form-item [label]="i18n.coverSystemNameLab" [helpContent]="i18n.coverSystemNameInfoLab">
            <n-checkbox id="service-ad-cover-system-name-enable"
                formControlName="ISENABLEOVERWRITESAMEACCOUNT"
                [label]="i18n.enableLab">
            </n-checkbox>
            <n-tip *ngIf="vm.value.ISENABLEOVERWRITESAMEACCOUNT"
                [type]="'abnormal'"
                [content]="i18n.coverSystemNameEnabledLab">
            </n-tip>
        </n-form-item>
        <!-- 域状态 -->
        <n-form-item [label]="i18n.domainStatusLab">
            <n-tip *ngIf="data.DOMAINSTATUS === DomainStatusE.JoinFailed"
                [type]="'failed'"
                style="margin:0px"
                [content]="str.domainStatusType[data.DOMAINSTATUS] || UNPLACEHOLDER">
            </n-tip>
            <span *ngIf="data.DOMAINSTATUS !== DomainStatusE.JoinFailed">{{str.domainStatusType[data.DOMAINSTATUS] || UNPLACEHOLDER}}</span>
            <n-tip *ngIf="data.DOMAINSTATUS === DomainStatusE.Logout  && +data.JOINDOMAINERRORCODE === 16"
                [type]="'info'"
                style="margin:0px"
                [content]="str.joinDomainErrorCodeObj[data.JOINDOMAINERRORCODE] || UNPLACEHOLDER">
            </n-tip>
        </n-form-item>
        <n-form-item *ngIf="data.DOMAINSTATUS === DomainStatusE.JoinFailed" [label]="i18n.joinDomainFailedReasonLab">
            <span>{{str.joinDomainErrorCodeObj[data.JOINDOMAINERRORCODE] || UNPLACEHOLDER}}</span>
        </n-form-item>
        <n-form-item>
            <div class="center interval-20">
                <!-- 加入域 -->
                <button id="join-in-domain"
                    nButton
                    [label]="i18n.joinDomainBtn"
                    [disabled]="data.DOMAINSTATUS !== DomainStatusE.Logout && data.DOMAINSTATUS !== DomainStatusE.JoinFailed"
                    (click)="joinDomain()">
                </button>
                <!-- 退出域 -->
                <button id="logout-domain"
                    nButton
                    [label]="i18n.logoutDomainBtn"
                    [disabled]="data.DOMAINSTATUS !== DomainStatusE.Join"
                    (click)="logoutDomain()">
                </button>
            </div>
        </n-form-item>
    </form>

    <n-footer>
        <button id="service-ad-close-btn"
            nButton
            [label]="i18n.closeBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
